/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createSelector } from 'reselect';

const INPUTS = [
  'vat',
];

const getCompany = state => state.user.company;
const getCompanyForm = state => state.companyForm;

export const makeRegisterCompanyForm = () =>
  createSelector([getCompany, getCompanyForm], (company, companyForm) => ({
    ...companyForm,
    fieldsets: companyForm.fieldsets.map(({ legend, inputs }) => ({
      legend,
      inputs: inputs
        .filter(input => INPUTS.indexOf(input.name) !== -1)
        .map(
          input =>
            typeof company[input.name] !== 'undefined'
              ? { ...input, value: company[input.name] }
              : input
        ),
    })),
  }));
